import { Inject, Injectable, LOCALE_ID, Renderer2 } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LocalesStateInterface } from '~/core/store/locales/locales.model';
import { LocalesService } from '~/core/store/locales/locales.service';
import { DOCUMENT, Location } from '@angular/common';
import { deserialize } from 'v8';
import { lastValueFrom } from 'rxjs';
import { allLangRegEx } from '~/core/constants/constants';

class Guid {
  static newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}

const regionObj = {
  curRegion: { label: "Europe", id: "EU" },
  list: [
    { label: "Europe", id: "EU" },
    { label: "South Africa", id: "ZA" },
    { label: "UK", id: "UK" }
  ]
}

const countryObj = {
  curCountry: { label: null, id: null },
  list: [
    { label: 'Austria', id: 'at' }, //OK
    { label: 'Bulgaria', id: 'bg' }, //OK
    { label: 'Czech Republic', id: 'cz' }, //OK
    { label: 'Croatia', id: 'hr' }, //OK
    { label: 'Denmark', id: 'dk' }, //OK
    { label: 'Estonia', id: 'ee' }, //OK
    { label: 'Finland', id: 'fi' }, //OK
    { label: 'France', id: 'fr' }, //OK
    { label: 'Germany', id: 'de' }, //OK
    { label: 'Hungary', id: 'hu' }, //OK
    { label: 'Italy', id: 'it' }, //OK
    { label: 'Latvia', id: 'lv' }, //OK
    { label: 'Lithuania', id: 'lt' }, //OK
    { label: 'Netherlands', id: 'nl' }, //OK
    { label: 'Poland', id: 'pl' }, //OK
    { label: 'Romania', id: 'ro' }, //OK
    { label: 'Slovenia', id: 'si' }, //OK
    { label: 'Slovakia', id: 'sk' }, //OK
    { label: 'Sweden', id: 'se' }, //OK
    { label: 'Spain', id: 'es' }, //OK
    { label: 'Serbia', id: 'rs' }, //OK
    { label: 'South Africa', id: 'za' }, //OK
    { label: 'Switzerland', id: 'ch-de' }, //OK
    { label: 'Switzerland', id: 'ch-fr' }, //OK
    { label: 'Switzerland', id: 'ch-it' }, //OK
    { label: 'Bosnia and Herzegovina', id: 'ba' }, //Cant set this language in the browser
    { label: 'Macedonia', id: 'mk' }, //Cant set this language in the browser
    { label: 'Norway', id: 'no' }, //Cant set this language in the browser
    { label: 'Belgium', id: 'be-nl' }, //Could not find this language in the browser
    { label: 'Belgium', id: 'be-fr' }, //Could not find this language in the browser
    { label: 'United Kingdom', id: 'gb' }, //OK
  ]
};

const langObj = {
  curLang: { label: 'English', id: 'en', apiResLang: 'en', code: 'en-US' },
  list: [
    { label: 'English', id: 'en', apiResLang: 'en', code: 'en-US' },
    { label: 'Lietuvių', id: 'lt', apiResLang: 'lt', code: 'lt-LT' },
    { label: 'Čeština', id: 'cz', apiResLang: 'cs', code: 'cs-CZ' },
    { label: 'Dansk', id: 'dk', apiResLang: 'da', code: 'da-DK' },
    { label: 'Français', id: 'fr', apiResLang: 'fr', code: 'fr-FR' },
    { label: 'Español', id: 'es', apiResLang: 'es', code: 'es-ES' },
    { label: 'Norsk', id: 'no', apiResLang: 'no', code: 'no-NO' },
    { label: 'Italiano', id: 'it', apiResLang: 'it', code: 'it-IT' },
    { label: 'Suomi', id: 'fi', apiResLang: 'fi', code: 'fi-FI' },
    { label: 'Polski', id: 'pl', apiResLang: 'pl', code: 'pl-PL' },
    { label: 'Magyar', id: 'hu', apiResLang: 'hu', code: 'hu-HU' },
    { label: 'Slovenčina', id: 'sk', apiResLang: 'sk', code: 'sk-SK' },
    { label: 'Slovenščina', id: 'si', apiResLang: 'si', code: 'sl-SI' },
    { label: 'Deutsch (AT)', id: 'at', apiResLang: 'de-at', code: 'de-AT' },
    { label: 'Română', id: 'ro', apiResLang: 'ro', code: 'ro-RO' },
    { label: 'Bosanski', id: 'ba', apiResLang: 'bs', code: 'bs-BA' },
    { label: 'Македонски', id: 'mk', apiResLang: 'mk', code: 'mk-MK' },
    { label: 'Српски', id: 'rs', apiResLang: 'rs', code: 'sr-RS' },
    { label: 'Hrvatski', id: 'hr', apiResLang: 'hr', code: 'hr-HR' },
    { label: 'Deutsch (DE)', id: 'de', apiResLang: 'de', code: 'de-DE' },
    { label: 'Nederlands', id: 'nl', apiResLang: 'nl', code: 'nl-NL' },
    { label: 'Български', id: 'bg', apiResLang: 'bg', code: 'bg-BG' },
    { label: 'Svenska', id: 'se', apiResLang: 'sv', code: 'sv-SE' },
    { label: 'Eesti', id: 'ee', apiResLang: 'et', code: 'et-EE' },
    { label: 'Latviešu', id: 'lv', apiResLang: 'lv', code: 'lv-LV' },
    { label: 'Русский', id: 'ru', apiResLang: 'ru', code: 'ru-RU' },
    { label: 'Français (BE)', id: 'be-fr', apiResLang: 'fr', code: 'fr-BE' },
    { label: 'Nederlands (BE)', id: 'be-nl', apiResLang: 'nl', code: 'nl-BE' },
    { label: 'Deutsch (CH)', id: 'ch-de', apiResLang: 'de', code: 'de-CH' },
    { label: 'Français (CH)', id: 'ch-fr', apiResLang: 'fr', code: 'fr-CH' },
    { label: 'Italiano (CH)', id: 'ch-it', apiResLang: 'it', code: 'it-CH' },
    { label: 'English', id: 'en-za', apiResLang: 'en-za', code: 'en-ZA' },
    { label: 'English', id: 'en-gb', apiResLang: 'en-gb', code: 'en-GB' },
    { label: 'English', id: 'en-tx', apiResLang: 'en-tx', code: 'en-TX' },
  ]
};

const OTIDs =
{
  'sv-SE': '7d36f3a5-968d-43fa-93d1-eed9de16b4d6',
  'it-IT': '69892ede-c00a-4e11-aa17-fb1a540cb281',
  'da-DK': '222dfb9f-6221-4f46-a953-1f7a17825854',
  'cs-CZ': '3afbc74b-5818-4d35-a867-f3848880b913',
  'lt-LT': '184d2c93-e210-4036-a55e-4fd387d205c9',
  'fr-FR': '127378c8-861f-4925-be7c-b4685a124d0f',
  'es-ES': 'c48f23bd-6839-4b0a-91fa-176e398dccb8',
  'no-NO': '39f2d7f0-4c17-450e-9818-6b6a545d6e01',
  'fi-FI': 'bad7d9af-cc61-4621-a8a7-dd6065ec4389',
  'pl-PL': '01351511-83d0-4a56-8158-aaea91750ff1',
  'hu-HU': '83b24b20-96a9-4b75-aad2-c04200ff9950',
  'sk-SK': '93cae329-ebe6-4a29-8603-5b14a4a9fbde',
  'sl-SI': 'f7300556-3e4f-4cba-bb22-8b4f48c93e05',
  'de-AT': 'a93d5847-8ce0-4700-8b1a-fa78995382df',
  'ro-RO': '46d72f49-0157-47a5-9cf1-a4f565fd14ee',
  'bs-BA': 'c6764366-9c0a-476b-835e-e4d9797f9183',
  'mk-MK': 'e5646cac-3e35-415a-b07a-48ca6f7cf6c0',
  'sr-RS': 'e2008f3b-7c28-4710-887c-2e16f5079983',
  'hr-HR': 'e10a0eaa-ff34-4075-854e-6614cfc8a75d',
  'de-DE': '3d1aa664-eca4-43e5-ade1-5ed9b0edd23b',
  'de-CH': '3d1aa664-eca4-43e5-ade1-5ed9b0edd23b',
  'nl-NL': 'e7e138e0-f2d6-4ccb-83f5-4689e4c9aae1',
  'nl-BE': '91504324-6fa9-4f37-a635-0b4fcb8d04ed',
  'fr-BE': '21f1015f-47a2-4467-953d-2c65070bf601',
  'fr-CH': '21f1015f-47a2-4467-953d-2c65070bf601',
  'en-GB': '2f19f6fe-bb51-4626-bb84-6ffb13f241bf',
  'en-US': '2f19f6fe-bb51-4626-bb84-6ffb13f241bf',
  'en-ZA': '2f19f6fe-bb51-4626-bb84-6ffb13f241bf',
  'et-EE': '411853b8-cb2f-4740-a08e-90f176d488c3',
  'bg-BG': 'beda58c5-f3d7-499e-a23d-533aacea24df',
  'lv-LV': '885ee9ed-003d-4b36-9bb7-9e723605f829',
}

const langList = ['/en/', '/cz/', '/dk/', '/lt/', '/ru/', '/fr/', '/es/', '/no/', '/it/', '/fi/', '/pl/', '/hu/', '/sk/', '/si/', '/at/', '/ro/', '/ba/', '/mk/', '/rs/', '/hr/', '/de/', '/be-nl/', '/be-fr/', '/nl/', '/bg/', '/se/', '/ee/', '/lv/', '/ch-de/', '/ch-fr/', '/ch-it/', '/en-za/', '/en-gb/'];

const nonEuLangObj = [
  { 'en-gb': '{"data":{},"lang":{"curLang":{"label":"English","id":"en-gb","apiResLang":"en-gb","code":"en-GB"},"list":[{"label":"English","id":"en","apiResLang":"en","code":"en-US"},{"label":"Lietuvių","id":"lt","apiResLang":"lt","code":"lt-LT"},{"label":"Čeština","id":"cz","apiResLang":"cs","code":"cs-CZ"},{"label":"Dansk","id":"dk","apiResLang":"da","code":"da-DK"},{"label":"Français","id":"fr","apiResLang":"fr","code":"fr-FR"},{"label":"Español","id":"es","apiResLang":"es","code":"es-ES"},{"label":"Norsk","id":"no","apiResLang":"no","code":"no-NO"},{"label":"Italiano","id":"it","apiResLang":"it","code":"it-IT"},{"label":"Suomi","id":"fi","apiResLang":"fi","code":"fi-FI"},{"label":"Polski","id":"pl","apiResLang":"pl","code":"pl-PL"},{"label":"Magyar","id":"hu","apiResLang":"hu","code":"hu-HU"},{"label":"Slovenčina","id":"sk","apiResLang":"sk","code":"sk-SK"},{"label":"Slovenščina","id":"si","apiResLang":"si","code":"sl-SI"},{"label":"Deutsch (AT)","id":"at","apiResLang":"de-at","code":"de-AT"},{"label":"Română","id":"ro","apiResLang":"ro","code":"ro-RO"},{"label":"Bosanski","id":"ba","apiResLang":"bs","code":"bs-BA"},{"label":"Македонски","id":"mk","apiResLang":"mk","code":"mk-MK"},{"label":"Српски","id":"rs","apiResLang":"rs","code":"sr-RS"},{"label":"Hrvatski","id":"hr","apiResLang":"hr","code":"hr-HR"},{"label":"Deutsch (DE)","id":"de","apiResLang":"de","code":"de-DE"},{"label":"Nederlands","id":"nl","apiResLang":"nl","code":"nl-NL"},{"label":"Български","id":"bg","apiResLang":"bg","code":"bg-BG"},{"label":"Svenska","id":"se","apiResLang":"sv","code":"sv-SE"},{"label":"Eesti","id":"ee","apiResLang":"et","code":"et-EE"},{"label":"Latviešu","id":"lv","apiResLang":"lv","code":"lv-LV"},{"label":"Русский","id":"ru","apiResLang":"ru","code":"ru-RU"},{"label":"Français (BE)","id":"be-fr","apiResLang":"fr","code":"fr-BE"},{"label":"Nederlands (BE)","id":"be-nl","apiResLang":"nl","code":"nl-BE"},{"label":"Deutsch (CH)","id":"ch-de","apiResLang":"de","code":"de-CH"},{"label":"Français (CH)","id":"ch-fr","apiResLang":"fr","code":"fr-CH"},{"label":"Italiano (CH)","id":"ch-it","apiResLang":"it","code":"it-CH"},{"label":"English","id":"en-za","apiResLang":"en-za","code":"en-ZA"},{"label":"English","id":"en-gb","apiResLang":"en-gb","code":"en-GB"},{"label":"English","id":"en-tx","apiResLang":"en-tx","code":"en-TX"}]},"region":{"curRegion":{"label":"UK","id":"UK"},"list":[{"label":"Europe","id":"EU"},{"label":"South Africa","id":"ZA"}]},"country":{"curCountry":{"label":null,"id":null},"list":[{"label":"Austria","id":"at"},{"label":"Belgium","id":"be-nl"},{"label":"Bosnia and Herzegovina","id":"ba"},{"label":"Bulgaria","id":"bg"},{"label":"Czech Republic","id":"cz"},{"label":"Croatia","id":"hr"},{"label":"Denmark","id":"dk"},{"label":"Estonia","id":"ee"},{"label":"Finland","id":"fi"},{"label":"France","id":"fr"},{"label":"Germany","id":"de"},{"label":"Hungary","id":"hu"},{"label":"Italy","id":"it"},{"label":"Latvia","id":"lv"},{"label":"Lithuania","id":"lt"},{"label":"Macedonia","id":"mk"},{"label":"Netherlands","id":"nl"},{"label":"Norway","id":"no"},{"label":"Poland","id":"pl"},{"label":"Romania","id":"ro"},{"label":"Switzerland","id":"ch-de"},{"label":"Slovenia","id":"si"},{"label":"Slovakia","id":"sk"},{"label":"Sweden","id":"se"},{"label":"Spain","id":"es"},{"label":"Serbia","id":"rs"},{"label":"South Africa","id":"za"},{"label":null,"id":null}]},"version":2}' },
  { 'en-tx': '{"data":{},"lang":{"curLang":{"label":"English","id":"en-tx","apiResLang":"en-tx","code":"en-TX"},"list":[{"label":"English","id":"en","apiResLang":"en","code":"en-US"},{"label":"Lietuvių","id":"lt","apiResLang":"lt","code":"lt-LT"},{"label":"Čeština","id":"cz","apiResLang":"cs","code":"cs-CZ"},{"label":"Dansk","id":"dk","apiResLang":"da","code":"da-DK"},{"label":"Français","id":"fr","apiResLang":"fr","code":"fr-FR"},{"label":"Español","id":"es","apiResLang":"es","code":"es-ES"},{"label":"Norsk","id":"no","apiResLang":"no","code":"no-NO"},{"label":"Italiano","id":"it","apiResLang":"it","code":"it-IT"},{"label":"Suomi","id":"fi","apiResLang":"fi","code":"fi-FI"},{"label":"Polski","id":"pl","apiResLang":"pl","code":"pl-PL"},{"label":"Magyar","id":"hu","apiResLang":"hu","code":"hu-HU"},{"label":"Slovenčina","id":"sk","apiResLang":"sk","code":"sk-SK"},{"label":"Slovenščina","id":"si","apiResLang":"si","code":"sl-SI"},{"label":"Deutsch (AT)","id":"at","apiResLang":"de-at","code":"de-AT"},{"label":"Română","id":"ro","apiResLang":"ro","code":"ro-RO"},{"label":"Bosanski","id":"ba","apiResLang":"bs","code":"bs-BA"},{"label":"Македонски","id":"mk","apiResLang":"mk","code":"mk-MK"},{"label":"Српски","id":"rs","apiResLang":"rs","code":"sr-RS"},{"label":"Hrvatski","id":"hr","apiResLang":"hr","code":"hr-HR"},{"label":"Deutsch (DE)","id":"de","apiResLang":"de","code":"de-DE"},{"label":"Nederlands","id":"nl","apiResLang":"nl","code":"nl-NL"},{"label":"Български","id":"bg","apiResLang":"bg","code":"bg-BG"},{"label":"Svenska","id":"se","apiResLang":"sv","code":"sv-SE"},{"label":"Eesti","id":"ee","apiResLang":"et","code":"et-EE"},{"label":"Latviešu","id":"lv","apiResLang":"lv","code":"lv-LV"},{"label":"Русский","id":"ru","apiResLang":"ru","code":"ru-RU"},{"label":"Français (BE)","id":"be-fr","apiResLang":"fr","code":"fr-BE"},{"label":"Nederlands (BE)","id":"be-nl","apiResLang":"nl","code":"nl-BE"},{"label":"Deutsch (CH)","id":"ch-de","apiResLang":"de","code":"de-CH"},{"label":"Français (CH)","id":"ch-fr","apiResLang":"fr","code":"fr-CH"},{"label":"Italiano (CH)","id":"ch-it","apiResLang":"it","code":"it-CH"},{"label":"English","id":"en-za","apiResLang":"en-za","code":"en-ZA"},{"label":"English","id":"en-gb","apiResLang":"en-gb","code":"en-GB"},{"label":"English","id":"en-tx","apiResLang":"en-tx","code":"en-TX"}]},"region":{"curRegion":{"label":"TX","id":"TX"},"list":[{"label":"Europe","id":"EU"},{"label":"South Africa","id":"ZA"}]},"country":{"curCountry":{"label":null,"id":null},"list":[{"label":"Austria","id":"at"},{"label":"Belgium","id":"be-nl"},{"label":"Bosnia and Herzegovina","id":"ba"},{"label":"Bulgaria","id":"bg"},{"label":"Czech Republic","id":"cz"},{"label":"Croatia","id":"hr"},{"label":"Denmark","id":"dk"},{"label":"Estonia","id":"ee"},{"label":"Finland","id":"fi"},{"label":"France","id":"fr"},{"label":"Germany","id":"de"},{"label":"Hungary","id":"hu"},{"label":"Italy","id":"it"},{"label":"Latvia","id":"lv"},{"label":"Lithuania","id":"lt"},{"label":"Macedonia","id":"mk"},{"label":"Netherlands","id":"nl"},{"label":"Norway","id":"no"},{"label":"Poland","id":"pl"},{"label":"Romania","id":"ro"},{"label":"Switzerland","id":"ch-de"},{"label":"Slovenia","id":"si"},{"label":"Slovakia","id":"sk"},{"label":"Sweden","id":"se"},{"label":"Spain","id":"es"},{"label":"Serbia","id":"rs"},{"label":"South Africa","id":"za"},{"label":null,"id":null}]},"version":2}' },
  { 'en': '{"data":{},"lang":{"curLang":{"label":"English","id":"en","apiResLang":"en","code":"en-US"},"list":[{"label":"English","id":"en","apiResLang":"en","code":"en-US"},{"label":"Lietuvių","id":"lt","apiResLang":"lt","code":"lt-LT"},{"label":"Čeština","id":"cz","apiResLang":"cs","code":"cs-CZ"},{"label":"Dansk","id":"dk","apiResLang":"da","code":"da-DK"},{"label":"Français","id":"fr","apiResLang":"fr","code":"fr-FR"},{"label":"Español","id":"es","apiResLang":"es","code":"es-ES"},{"label":"Norsk","id":"no","apiResLang":"no","code":"no-NO"},{"label":"Italiano","id":"it","apiResLang":"it","code":"it-IT"},{"label":"Suomi","id":"fi","apiResLang":"fi","code":"fi-FI"},{"label":"Polski","id":"pl","apiResLang":"pl","code":"pl-PL"},{"label":"Magyar","id":"hu","apiResLang":"hu","code":"hu-HU"},{"label":"Slovenčina","id":"sk","apiResLang":"sk","code":"sk-SK"},{"label":"Slovenščina","id":"si","apiResLang":"si","code":"sl-SI"},{"label":"Deutsch (AT)","id":"at","apiResLang":"de-at","code":"de-AT"},{"label":"Română","id":"ro","apiResLang":"ro","code":"ro-RO"},{"label":"Bosanski","id":"ba","apiResLang":"bs","code":"bs-BA"},{"label":"Македонски","id":"mk","apiResLang":"mk","code":"mk-MK"},{"label":"Српски","id":"rs","apiResLang":"rs","code":"sr-RS"},{"label":"Hrvatski","id":"hr","apiResLang":"hr","code":"hr-HR"},{"label":"Deutsch (DE)","id":"de","apiResLang":"de","code":"de-DE"},{"label":"Nederlands","id":"nl","apiResLang":"nl","code":"nl-NL"},{"label":"Български","id":"bg","apiResLang":"bg","code":"bg-BG"},{"label":"Svenska","id":"se","apiResLang":"sv","code":"sv-SE"},{"label":"Eesti","id":"ee","apiResLang":"et","code":"et-EE"},{"label":"Latviešu","id":"lv","apiResLang":"lv","code":"lv-LV"},{"label":"Русский","id":"ru","apiResLang":"ru","code":"ru-RU"},{"label":"Français (BE)","id":"be-fr","apiResLang":"fr","code":"fr-BE"},{"label":"Nederlands (BE)","id":"be-nl","apiResLang":"nl","code":"nl-BE"},{"label":"Deutsch (CH)","id":"ch-de","apiResLang":"de","code":"de-CH"},{"label":"Français (CH)","id":"ch-fr","apiResLang":"fr","code":"fr-CH"},{"label":"Italiano (CH)","id":"ch-it","apiResLang":"it","code":"it-CH"},{"label":"English","id":"en-za","apiResLang":"en-za","code":"en-ZA"},{"label":"English","id":"en-gb","apiResLang":"en-gb","code":"en-GB"},{"label":"English","id":"en-tx","apiResLang":"en-tx","code":"en-TX"}]},"region":{"curRegion":{"label":"undefined","id":"undefined"},"list":[{"label":"Europe","id":"EU"},{"label":"South Africa","id":"ZA"}]},"country":{"curCountry":{"label":null,"id":null},"list":[{"label":"Austria","id":"at"},{"label":"Belgium","id":"be-nl"},{"label":"Bosnia and Herzegovina","id":"ba"},{"label":"Bulgaria","id":"bg"},{"label":"Czech Republic","id":"cz"},{"label":"Croatia","id":"hr"},{"label":"Denmark","id":"dk"},{"label":"Estonia","id":"ee"},{"label":"Finland","id":"fi"},{"label":"France","id":"fr"},{"label":"Germany","id":"de"},{"label":"Hungary","id":"hu"},{"label":"Italy","id":"it"},{"label":"Latvia","id":"lv"},{"label":"Lithuania","id":"lt"},{"label":"Macedonia","id":"mk"},{"label":"Netherlands","id":"nl"},{"label":"Norway","id":"no"},{"label":"Poland","id":"pl"},{"label":"Romania","id":"ro"},{"label":"Switzerland","id":"ch-de"},{"label":"Slovenia","id":"si"},{"label":"Slovakia","id":"sk"},{"label":"Sweden","id":"se"},{"label":"Spain","id":"es"},{"label":"Serbia","id":"rs"},{"label":"South Africa","id":"za"},{"label":null,"id":null}]},"version":2}' },
]
@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(
    private http: HttpClient,
    public location: Location,
    public localesService: LocalesService,
  ) { }
  version = 2;

  baseUrl = environment.tokenProxyUrl;

  private token = '';
  public userId = '';
  public roles: string[];
  public expires: number;
  private tokenTime: number;
  private workerStarted = false;
  private fromTranslationService = false;
  workerIsStarted = false;

  getToken() {
    return this.token;
  }

  async load(fromTranslationService: boolean): Promise<any> {
    this.fromTranslationService = fromTranslationService;
    if (!fromTranslationService) {
      let host = window.location.host;
      let isSelectedSite = host.includes(environment.selectedSiteUrl);
      if (isSelectedSite) {
        this.ensureLocalStorageLangObject(this.version, this.location);
      } else {
        this.ensureNonEuLocalStorageObject(host);
      }
    }

    if (!environment.development) {
      const headers = new HttpHeaders({ 'No-Auth': 'True' });
      const result = await lastValueFrom(this.http.get(this.baseUrl, { headers })) as any;

      if (result !== null) {
        this.token = result.access_token;
        this.expires = result.expires as number;
        this.tokenTime = Date.now();
      }

      if (this.workerStarted === false) {
        this.workerStarted = true;
        this.startWorker();
      }

      return result;
    } else {
      return null;
    }
  }
  startWorker() {
    setInterval(() => {
      this.load(this.fromTranslationService).then();
    }, 1000 * 60 * 10);
  }

  private ensureNonEuLocalStorageObject(host: string) {
    host = host.split(':')[0].replace('www.', '');

    const txSiteUrls = new Set([
      'volvousedtrucks.co.uk',
      'tradeandexport.volvotrucks.com',
      'tradeandexporttrucks.co.uk',
      'tradeandexporttrucks.com',
      'usedtrucks.volvonorthandscotland.co.uk',
      'localhost'
    ]);

    switch (host) {
      case environment.ukSiteUrl:
        localStorage.setItem('language', this.getNonEuLangObj('en-gb'));
        break;
      default:
        localStorage.setItem('language', this.getNonEuLangObj('en-tx'));
        break;
    }

    this.addOneTrustScripts('en-GB');
    this.ensureNotificationHighlightState();
  }

  private getNonEuLangObj(langCode: string): string {
    return nonEuLangObj.find(langItem => langItem[langCode])[langCode];
  }

  private ensureLocalStorageLangObject(version: number, location: Location) {
    let isValid = false;
    let languageItem = localStorage.getItem('language');

    let deserializedLanguageItem: LocalesStateInterface;
    try {
      deserializedLanguageItem = JSON.parse(languageItem);
      isValid =
        !(Object.keys(deserializedLanguageItem).length === 0) &&
        deserializedLanguageItem.lang !== undefined &&
        deserializedLanguageItem.lang.curLang !== undefined &&
        deserializedLanguageItem.country !== undefined &&
        deserializedLanguageItem.country.curCountry !== undefined &&
        deserializedLanguageItem.region !== undefined &&
        deserializedLanguageItem.region.curRegion !== undefined &&
        deserializedLanguageItem.region.curRegion.id !== 'TX' &&
        deserializedLanguageItem.region.curRegion.id !== 'UK'
    } catch (exp) {
      isValid = false;
    }

    if (!isValid) {
      deserializedLanguageItem = JSON.parse(this.getNonEuLangObj('en'));
    }

    var currentLocation = location.path();
    console.log(currentLocation);
    const FromRegionalPopup = currentLocation.includes('FromRegionalPopup');

    const FromNotificationUnSubscribe = currentLocation.includes('unsubscribe');

    if (FromRegionalPopup) {
      currentLocation = currentLocation.replace('?FromRegionalPopup', '');
      location.replaceState(currentLocation);
    }
    //We are checking this if condition because we do not want to replace state for our stock
    var queryString = currentLocation.split('?')[1];

    if (queryString && queryString.includes('email=')) { //To track if user is navigating from notification email.
      if (!sessionStorage.getItem('email'))
        sessionStorage.setItem('email', 'true');
    }
    if (queryString && queryString.includes('qf=')) {
      //do nothing
    }
    else {
      // delete everything after ? in the url
      currentLocation = currentLocation.split('?')[0];
      if (!FromNotificationUnSubscribe) //Do not remove query parameters if the url has unsubscribe(Notification email)
        location.replaceState(currentLocation);
    }
    let hasLangInUrl = allLangRegEx.test(location.path());

    if (hasLangInUrl) {
      let langCode = this.containsOrDefault(currentLocation, langList);
      if (langCode) {
        deserializedLanguageItem.lang.curLang = langObj.list.find(langItem => langItem.id === langCode);
        if (!FromRegionalPopup) {
          var countryCodeFromList = countryObj.list.find(countryItem => countryItem.id === (langCode as string).replace('en-', ''));
          if (!countryCodeFromList) {
            countryCodeFromList = { label: null, id: null }
          };
          deserializedLanguageItem.country.curCountry = countryCodeFromList;
          if (countryCodeFromList.id === 'za')
            deserializedLanguageItem.region.curRegion = regionObj.list.find(regionItem => regionItem.id === 'ZA');
          else
            deserializedLanguageItem.region.curRegion = { label: 'Europe', id: 'EU' };
        }
      }
    } else {
      if (!isValid) {
        deserializedLanguageItem = this.getBrowserLang();
      }
    }

    localStorage.setItem('LOCALIZE_DEFAULT_LANGUAGE', deserializedLanguageItem.lang.curLang.id);

    localStorage.setItem('language', JSON.stringify(deserializedLanguageItem));
    const code = langObj.list.find(langItem => langItem.id === deserializedLanguageItem.lang.curLang.id).code;
    document.documentElement.setAttribute('lang', code);
    this.addOneTrustScripts(code);
    this.ensureNotificationHighlightState();
  }

  addOneTrustScripts(code: string) {
    const domainScript = environment.production ? OTIDs[code] : `${OTIDs[code]}-test`;
    console.log('Domain script OTID:', domainScript);
    const autoBlockUrl = environment.production
      ? `https://cdn.cookielaw.org/consent/${OTIDs[code]}/OtAutoBlock.js`
      : `https://cdn.cookielaw.org/consent/${OTIDs[code]}-test/OtAutoBlock.js`;
    const sdkStubUrl = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'; // No environment check needed for stub usually

    // --- OtAutoBlock Script (Consider if needed - Stub might load it) ---
    // You might even be able to remove adding OtAutoBlock explicitly,
    // as the SDK Stub often loads it automatically based on your OneTrust configuration.
    // Check your OneTrust setup if Auto-blocking is enabled.
    if (!document.getElementById('otAutoBlockScript')) {
      const oneTrustScript1 = document.createElement('script');
      oneTrustScript1.id = 'otAutoBlockScript';
      oneTrustScript1.src = autoBlockUrl;
      oneTrustScript1.type = 'text/javascript';
      // Add error handling if needed
      oneTrustScript1.onerror = () => console.error('Failed to load OneTrust AutoBlock script');
      document.getElementsByTagName('head')[0].appendChild(oneTrustScript1);
      console.log('OneTrust AutoBlock script added (or attempt initiated)');
    } else {
      console.log('OneTrust AutoBlock script already present');
    }


    // --- otSDKStub Script (No onload handler!) ---
    if (!document.getElementById('otSDKStubScript')) {
      const oneTrustScript2 = document.createElement('script');
      oneTrustScript2.id = 'otSDKStubScript';
      oneTrustScript2.src = sdkStubUrl;
      oneTrustScript2.setAttribute('data-document-language', 'true');
      oneTrustScript2.type = 'text/javascript';
      oneTrustScript2.charset = 'UTF-8';
      oneTrustScript2.setAttribute('data-domain-script', domainScript);

      // REMOVED onload handler
      // Add error handling for the stub itself
      oneTrustScript2.onerror = () => {
        console.error('Failed to load OneTrust SDK Stub script');
      };

      document.getElementsByTagName('head')[0].appendChild(oneTrustScript2);
      console.log('OneTrust SDK Stub script added:', oneTrustScript2);
      // Log attributes just for debugging if needed
      console.log('OneTrust script attributes:', oneTrustScript2.attributes);
      console.log('OneTrust script src:', oneTrustScript2.src);

    } else {
      console.log('OneTrust SDK Stub script already present');
      // If already present, ensure the data-domain-script is correct for the current language/context
      const existingScript = document.getElementById('otSDKStubScript');
      if (existingScript && existingScript.getAttribute('data-domain-script') !== domainScript) {
        console.warn('Existing OneTrust script has different domain script ID. Re-evaluation might be needed.');
        // Potentially remove and re-add, or handle differently depending on requirements
      }
    }

    // --- OptanonWrapper Script (Keep this as is) ---
    if (!document.getElementById('optanonWrapperScript')) {
      const oneTrustScript3 = document.createElement('script');
      oneTrustScript3.id = 'optanonWrapperScript';
      oneTrustScript3.type = 'text/javascript';
      oneTrustScript3.innerHTML = 'function OptanonWrapper() { /* You can add logging here IF needed, but it will be called by OT */ console.log("OptanonWrapper CALLED BY OneTrust"); }';
      document.getElementsByTagName('head')[0].appendChild(oneTrustScript3);
      console.log('OptanonWrapper script added:', oneTrustScript3);
    } else {
      console.log('OptanonWrapper script already present');
    }

    // Initial cookie check might still show nothing here, as OT is async
    console.log('Initial document cookies (after script tags added):', document.cookie);
  }

  ensureNotificationHighlightState() {
    const state = localStorage.getItem("notSeenNotificationHighlight");

    if (state === null || state === undefined) {
      localStorage.setItem("notSeenNotificationHighlight", "true");
    }
  }

  containsOrDefault(str: string, arr: string[]): string | void {
    const langCode = str.replace('?', '/').split('/')[1];
    if (arr.map(element => element.split('/')[1]).includes(langCode))
      return langCode;
    else
      return 'en';
  }

  getBrowserLang() {
    let browserLang = navigator.language;

    let deserializedLanguageItem = {
      data: {},
      lang: langObj,
      region: regionObj,
      country: countryObj,
      version: this.version
    };

    let lang = '';
    let country = '';
    let region = '';

    const isSupported = langObj.list.some(l => l.id === browserLang.split('-')[0]);

    if (
      browserLang.includes('-') &&
      browserLang.split('-')[0] === "en" &&
      browserLang.split('-')[1] !== "ZA"
      || !isSupported) {
      lang = "en";
      country = undefined;
      region = "EU";
    }

    switch (browserLang) {
      case 'en-ZA':
        lang = 'en-za';
        country = 'za';
        region = 'ZA';
        break;
      case 'de-AT':
        lang = 'de';
        country = 'at';
        region = 'EU';
        break;
      case 'de-CH':
        lang = 'de';
        country = 'ch-de';
        region = 'EU';
        break;
      case 'nb':
        lang = 'no';
        country = 'no';
        region = 'EU';
        break;
      case 'nn':
        lang = 'no';
        country = 'no';
        region = 'EU';
        break;
      case 'sl':
        lang = 'si';
        country = 'si';
        region = 'EU';
        break;
      default:
        lang = lang === '' ? browserLang.split('-')[0] : lang;
        country = langObj.list.find(langItem => langItem.apiResLang === lang).id;
        region = "EU";
    }

    deserializedLanguageItem.lang.curLang = langObj.list.find(langItem => langItem.apiResLang === lang);
    deserializedLanguageItem.country.curCountry = country === "en" ? countryObj.curCountry : countryObj.list.find(countryItem => countryItem.id === country);
    deserializedLanguageItem.region.curRegion = regionObj.list.find(regionItem => regionItem.id === region);

    return deserializedLanguageItem;
  }
}

